import { ColumnFilter } from './ColumnFilter';  // Assuming you have this custom filter component

// Function to format numbers as currency, e.g., $100.00
function currencyFormat(value) {
    return `$${parseFloat(value).toFixed(2)}`;
}

// Function to format dates (if you have any date fields)
function dateFormat(value) {
    let objectDate = new Date(value);
    let day = ("0" + objectDate.getDate()).slice(-2);
    let month = ("0" + (objectDate.getMonth() + 1)).slice(-2);
    let year = objectDate.getFullYear();
    
    return day + "/" + month + "/" + year;
}
 
export const COLUMNS = [
    {
        Header: 'Part ID',
        Footer: 'Part ID',
        accessor: 'PartID',
        Filter: ColumnFilter,
        disableFilters: true  // You can disable filters if not needed for this column
    },
    {
        Header: '  فئة القطعة ',
        Footer: 'PartClassName',
        accessor: 'part_class.PartClassName', // Update accessor for nested object    
            Filter: ColumnFilter,
    },
    {
        Header: 'اسم القطعة',
        Footer: 'Part Name',
        accessor: 'PartName',
        Filter: ColumnFilter,
    },
     
    {
        Header: 'سعر الشراء',
        Footer: 'Cost',
        accessor: 'Cost',
        Filter: ColumnFilter,
        Cell: ({ value }) => currencyFormat(value),  // Format the cost as currency
    },
    {
        Header: 'كمية المخزون',
        Footer: 'Stock Quantity',
        accessor: 'total_stock_quantity',
        Filter: ColumnFilter,
    },
        {
        Header: 'سعر البيع',
        Footer: 'Purchase Price',
        accessor: 'PurchasePrice',
        Filter: ColumnFilter,
        Cell: ({ value }) => currencyFormat(value),  // Format the purchase price as currency
    },
     
    {
        Header: 'بلد الصنع',
        Footer: 'Country of Manufacture',
        accessor: 'CountryOfManufacture',
        Filter: ColumnFilter,
    },
    {
        Header: 'الحالة',
        Footer: 'Status',
        accessor: 'Status',
        Filter: ColumnFilter,
    },
    
];
